/* The goal uses Shopify minor currency units and the discounted cart subtotal. */
function hamiltonShippingState(total, goal, currency, goalCurrency) {
  const valid = Number.isFinite(total) && total >= 0 && Number.isFinite(goal) && goal > 0;
  const visible = valid && currency === goalCurrency;
  return {
    visible,
    remaining: visible ? Math.max(0, goal - total) : 0,
    progress: visible ? Math.min(100, total / goal * 100) : 0,
    reached: visible && total >= goal
  };
}

(() => {
  const drawer = document.querySelector('.hamilton-cart');
  const configNode = drawer?.querySelector('[data-hamilton-cart-config]');
  if (!configNode) return;
  let config;
  try { config = JSON.parse(configNode.textContent); } catch { return; }
  const shipping = drawer.querySelector('[data-cart-shipping]');
  const message = drawer.querySelector('[data-cart-shipping-message]');
  const progress = drawer.querySelector('[data-cart-shipping-progress]');
  const emptyContinue = drawer.querySelector('[data-cart-empty-continue]');
  let formatter;
  try {
    const locale = config.locale === 'es' && config.currency === 'MXN' ? 'es-MX' : config.locale;
    formatter = new Intl.NumberFormat(locale || 'es-MX', {
      style: 'currency', currency: config.currency, currencyDisplay: 'narrowSymbol'
    });
  } catch { return; }
  const update = cart => {
    if (!cart) return;
    const state = hamiltonShippingState(cart.total_price, config.goal, cart.currency, config.currency);
    const empty = cart.item_count === 0;
    shipping.hidden = !config.enabled || !state.visible || empty;
    emptyContinue.hidden = !empty;
    drawer.querySelector('[data-cart-currency]').textContent = cart.currency || config.currency;
    if (!shipping.hidden) {
      const text = state.reached ? config.success : config.pending.replaceAll('[monto]', `${formatter.format(state.remaining / 100)} ${config.currency}`);
      if (message.textContent !== text) message.textContent = text;
      progress.value = state.progress;
      progress.setAttribute('aria-valuetext', text);
    }
  };
  // These events are emitted by the existing controller after confirmed requests.
  document.addEventListener('flu:cart:updated', event => update(event.detail?.cart));
  document.addEventListener('flu:quick-cart:open', event => update(event.detail?.cart));
  drawer.querySelectorAll('[data-cart-continue], [data-cart-empty-continue]').forEach(button => {
    button.addEventListener('click', () => drawer.querySelector('.js-close').click());
  });
  update(config.cart);
})();
